import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/app/vaults/strategy-vaults/[vaultAddress]/page.tsx");
